module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/assets/translations/translationsJa.json
// module id = YFSa
// module chunks = 1